import { createTracker } from 'usage-tracker';
import events from 'campaigns-lib/events.yaml';
export const UsageTracker = createTracker({
  events,
  properties: {
    namespace: 'campaigns-lib'
  }
});
export const StandaloneUsageTracker = createTracker({
  standalone: true,
  properties: {
    namespace: 'campaigns-lib'
  }
});
export const popoverClickTracker = ({
  objectType,
  value
}) => {
  StandaloneUsageTracker.track('Campaigns Lib', 'Popover Label Clicked', {
    action: 'Popover Label Clicked',
    assetType: objectType,
    campaignId: value
  });
};
export const trackEmptyLabelButtonClicked = ({
  objectType,
  campaignId
}) => {
  StandaloneUsageTracker.track('Campaigns Lib', 'Popover Placeholder Interaction', {
    campaignId,
    objectType
  });
};
export const trackFormCampaignAssociationMade = ({
  formId,
  campaignId,
  entryPoint
}) => StandaloneUsageTracker.track('Campaigns', 'Campaign Form Association', {
  formId,
  campaignId,
  entryPoint
});